import React, { Component } from 'react';
import { CommonlyHeadMembers } from '../../common/headnav';
import { WingBlank, WhiteSpace } from 'antd-mobile';
import './style.less';
export default class IntegralSysm extends Component {
    render() {
        return <div className="integral">
            <CommonlyHeadMembers barname='使用说明' />
            <div className="sysm">
                <WingBlank size="lg">
                    <div className="sub-title">如何使用健康积分</div>
                    <WhiteSpace />
                    <div className="sysmdiv">
                        <span className="num">1</span>
                        <p>关注微信公众号“全人体检通”，点“体检通”按钮选择“身份证预约”进行体检预约。</p>
                    </div>
                    <div className="sysmdiv">
                        <span className="num">2</span>
                        <p>前往预约服务机构前台，出示身份证，开始体检。</p>
                    </div>
                    <div className="sysmdiv">
                        <span className="num">3</span>
                        <p>检查结束后上交体检表或相关资料。（，以便查询检查结果）。
</p>
                    </div>
                    <div className="sysmdiv">
                        <span className="num">4</span>
                        <p>一般情况下4-7个工作日即可通过微信公众号“全人体检通”查询检查结果。</p>
                    </div>                    
                    <WhiteSpace />
                </WingBlank>
            </div>
        </div>;
    }
}